var map = {
	"./en/common.json": [
		3368,
		3368
	],
	"./en/error-fallback.json": [
		68107,
		68107
	],
	"./en/glossary.json": [
		31684,
		31684
	],
	"./en/header.json": [
		64073,
		64073
	],
	"./en/not-found.json": [
		31939,
		31939
	],
	"./en/rewards.json": [
		33334,
		33334
	],
	"./en/wallet.json": [
		86782,
		86782
	],
	"./en/warnings.json": [
		91067,
		91067
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10548;
module.exports = webpackAsyncContext;